import { useDispatch } from "react-redux";
import { useEffect, useState, useCallback } from "react";
import { getBannerAction } from "../../features/user/userSlice";

export const useBanner = (keyword) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loadingBanner, setLoadingBanner] = useState(false);

  const fetchBanner = useCallback(async () => {
    if (!keyword) return;
    setLoadingBanner(true);
    setError(null);
    try {
      const res = await dispatch(getBannerAction({ type: keyword }));

      // ✅ FIX: only update if response has real data
      if (res?.data?.data) {
        setData(res.data.data);
      }

    } catch (err) {
      console.log(err);
      setError(err);
    } finally {
      setLoadingBanner(false);
    }
  }, [keyword, dispatch]);

  useEffect(() => {
    fetchBanner();
  }, [fetchBanner]); // ✅ good practice to include dependency

  return {
    data,
    loadingBanner,
    error,
    refetch: fetchBanner,
  };
};



